import { useV2ListLandingPageContentQuery } from "@generated";

const useConditionalLandingPageContent = () => {
  const { data: landingPageContent, isLoading: isContentLoading } =
    useV2ListLandingPageContentQuery({});

  return {
    data: landingPageContent,
    isLoading: isContentLoading,
  };
};

export default useConditionalLandingPageContent;
